import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  highlighted: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.string,
  priceText: PropTypes.string,
  buttonText: PropTypes.string,
  highlightColor: PropTypes.string,
}

const defaultProps = {
  highlighted: false,
  highlightColor: "#ed1558",
}

class PricingSlot extends React.Component {
  render() {
    const {highlighted} = this.props
    return (
      <div className='Grid-cell'>
        <ul className='price basic-border'>
          <li id={(highlighted ? "highlighted" : "basic") + "-header"} className={(highlighted ? "highlighted" : "basic") + "-header"}>{this.props.title}</li>
          <li className='tag'>{this.props.priceText}</li>
          {this.props.children}
        </ul>
      </div>
    )
  }
}

PricingSlot.propTypes = propTypes
PricingSlot.defaultProps = defaultProps

export default PricingSlot



// WEBPACK FOOTER //
// ./src/components/PricingSlot.js